import React from "react";
import { Button, message, Popconfirm, Tag } from "antd";

class FakeOrderButton extends React.Component {

    constructor(props) {
        super(props);

        if (!props.cartId) {
            throw "FakeOrderButton.props.cartId is required";
        }

    }

    render() {

        const { fakeOrder } = this.props

        return (
            <Popconfirm
                disabled={fakeOrder}
                onConfirm={this.onClickConfirm}
                okText="Confirm"
                title="This will cancel the order and mark it as fake! Quickbook data will be voided as well!">

                <Button
                    disabled={fakeOrder} type="danger">
                    Set As Fake Order
            </Button>

            </Popconfirm>
        )
    }

    onClickConfirm = () => {
        this.props.onConfirm()
    }

}

export default FakeOrderButton


// WEBPACK FOOTER //
// ./src/components/orders-v3/set-fake-order-button.js